import React from 'react'
import { Modal } from '../../_EOS/Modal'
import { Size } from '../../../hooks/useModal'
import { ConfirmAction } from '../../ConfirmAction'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Box, Typography } from '@mui/material'
import { patchPositionAlertId, postPositionAlertId } from '../config/api'

interface extendedProps {
  positionAlertIds: number[]
}

interface ResolveAlertModalProps {
  isOpen: boolean
  size: Size
  title: string
  extendedProps?: extendedProps
  closeModal: () => void
  handleCloseModalMessage: (succes: boolean, message: string) => void
}

export const ResolveAlertModal: React.FC<ResolveAlertModalProps> = ({
  isOpen,
  closeModal,
  size,
  title,
  extendedProps,
  handleCloseModalMessage
}) => {
  const { state, callApi } = useApi()

  const requestSingleResolveAlert = (positionAlertIds: number[]) => {
    callApi(patchPositionAlertId(positionAlertIds))
      .then(() =>
        handleCloseModalMessage(true, 'Alerta resueltas correctamente')
      )
      .catch((error) => handleCloseModalMessage(false, error))
  }

  const requestMassiveResolveAlert = (positionAlertIds: number[]) => {
    callApi(postPositionAlertId(positionAlertIds))
      .then(() =>
        handleCloseModalMessage(true, 'Alertas resueltas correctamente')
      )
      .catch(() =>
        handleCloseModalMessage(false, 'Hubo un error al resolver las alertas')
      )
  }

  if (!extendedProps || extendedProps?.positionAlertIds.length === 0) {
    return (
      <Modal open={isOpen} onClose={closeModal} maxWidth={size} title={title}>
        <Typography variant='h4'>
          No se ha seleccionado ningún elemento
        </Typography>
      </Modal>
    )
  }

  return (
    <Modal open={isOpen} onClose={closeModal} maxWidth={size} title={title}>
      {extendedProps.positionAlertIds !== undefined && (
        <Box padding={5}>
          <ConfirmAction
            handleSubmitAction={() =>
              extendedProps.positionAlertIds.length === 1
                ? requestSingleResolveAlert(extendedProps.positionAlertIds)
                : requestMassiveResolveAlert(extendedProps.positionAlertIds)
            }
            handleCloseModal={closeModal}
            confirmTitle={
              '¿Está seguro que desea resolver los elementos seleccionados?'
            }
            confirmText={'Resolver'}
            negateText={'Cancelar'}
            isLoading={state.status === Status.Loading}
          />
        </Box>
      )}
      {!extendedProps.positionAlertIds && (
        <Typography variant='body2'>
          No se ha seleccionado ningún elemento
        </Typography>
      )}
    </Modal>
  )
}
